import { useListVendorsForAccountQuery } from "@generated";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";

const useListVendors = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  let customError: string | null = null; // Declare customError

  const { data, error, isLoading, refetch, isFetching } =
    useListVendorsForAccountQuery({
      slug: accountSlug,
      filter: { active: true },
      page: { size: 1000 },
    });

  let vendors: { label: string; value: string }[] = [];

  if (data?.data) {
    try {
      vendors = data.data.map((vendor) => {
        if (!vendor.id) {
          throw new Error("Missing vendor.id");
        }
        if (!vendor.attributes?.name) {
          throw new Error("Missing vendor.attributes.name");
        }

        return {
          label: vendor.attributes.name,
          value: String(vendor.id),
        };
      });
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }
  return {
    vendors,
    isLoading,
    error: error ?? customError,
    refetchVendors: refetch,
    isFetching,
  };
};
export default useListVendors;
